import { VisibleSection } from "components/common/VisibleSection";
import { ExtendTermHeader } from "components/ExtendRemainingTerm/ExtendTermHeader";
import { RequestRepaymentHolidayHeader } from "components/RequestRepaymentHoliday/RequestRepaymentHolidayHeader";
import { Menu, TreatmentOptions } from "domain/menuOptions";

type AppSummaryHeadingProps = {
  treatmentOption: TreatmentOptions;
};
export const AppSummaryHeading = ({
  treatmentOption,
}: AppSummaryHeadingProps) => {
  const isRepaymentHoliday = treatmentOption === Menu.RequestRepaymentHoliday;
  const isExtendTerm = treatmentOption === Menu.ExtendTerm;
  return (
    <>
      <VisibleSection visible={isRepaymentHoliday}>
        <RequestRepaymentHolidayHeader />
      </VisibleSection>
      <VisibleSection visible={isExtendTerm}>
        <ExtendTermHeader />
      </VisibleSection>
    </>
  );
};
